import { BiChevronLeft, BiChevronRight, BiFirstPage, BiLastPage } from "react-icons/bi";

const PaginateSection = ({handlePlbPageChange,plbPaginatedata,data})=>{
  const totalItems = data?.length || 0;
  const totalPageCount = Math.ceil(totalItems / plbPaginatedata?.pageSize);
  const handleBackspace = (e) => {
    if (e.keyCode == 8) {
      e.preventDefault();
      e.target.select();
    }
  }
  console.log(data?.length === plbPaginatedata?.currentPage,data?.length,plbPaginatedata?.currentPage,totalPageCount)

  return(
                            <div className="rightside-block exclude-disabled plb-paginate-button-container">
                              <span
                                tabIndex="-1"
                                className={`py-0 m-0 btn pagination-btn btn-sm ${plbPaginatedata?.currentPage === 1 ? "disabled-span" : ""}`}
                                onClick={() => handlePlbPageChange(1)}
                              >
                                <span>
                                  <BiFirstPage
                                    size="1.3em"
                                    style={
                                      plbPaginatedata?.currentPage === 1
                                        ? { color: "black" }
                                        : { color: "black" }
                                    }
                                  />
                                </span>
                              </span>
                              <span
                                tabIndex="-1"
                                className={`py-0 m-0 btn pagination-btn btn-sm ${plbPaginatedata?.currentPage === 1 ? "disabled-span" : ""}`}
                                disabled={plbPaginatedata?.currentPage === 1 ? true : false}
                                onClick={() => handlePlbPageChange(plbPaginatedata?.currentPage - 1)}
                              >
                                <BiChevronLeft
                                  size="1.3em"
                                  style={
                                    plbPaginatedata?.currentPage === 1
                                      ? { color: "black" }
                                      : { color: "black" }
                                  }
                                />
                              </span>
                              <div className="pagenum-sub">
                                <input
                                  data-not-take-field-count="true"
                                  tabIndex="-1"
                                  className="prevent-shift viewer-toolbar-current-page-input w-82"
                                  type="text"
                                  value={plbPaginatedata?.currentPage}
                                  onKeyDown={(e) => handleBackspace(e)}
                                onChange={(e) => {
                                  const input = e.target;
                                  if (input.value) {
                                      handlePlbPageChange(input.value);
                                  }
                              }}
                                />{" "}
                                / {totalPageCount}
                              </div>
                              <span
                                tabIndex="-1"
                                className={`py-0 m-0 pagination-btn btn btn-sm ${plbPaginatedata?.currentPage === totalPageCount ? "disabled-span" : ""}`}
                                onClick={(e) => {
                                  handlePlbPageChange(plbPaginatedata?.currentPage + 1)
                                }}
                              >
                                <BiChevronRight
                                  size="1.3em"
                                  style={
                                    data?.length === plbPaginatedata?.currentPage
                                      ? { color: "black" }
                                      : { color: "black" }
                                  }
                                />
                              </span>
                              <span
                                tabIndex="-1"
                                className={`py-0  btn pagination-btn btn-sm ${plbPaginatedata?.currentPage === totalPageCount ? "disabled-span" : ""}`}
                                disabled={plbPaginatedata?.currentPage === totalPageCount}
                                onClick={(e) => {
                                  handlePlbPageChange(totalPageCount)
                                }}
                              >
                                <span>
                                  <BiLastPage
                                    size="1.3em"
                                    style={
                                      data?.length === plbPaginatedata?.currentPage
                                        ? { color: "black" }
                                        : { color: "black" }
                                    }
                                  />
                                </span>
                              </span>
                            </div>
        )
}
export default PaginateSection